/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboCalculationDetailRequestSchema } from "./comboCalculationDetailRequestSchema.ts";
import { mobileOrderItemCreateRequestSchema } from "./mobileOrderItemCreateRequestSchema.ts";

export const mobileOrderCreateRequestSchema = z.object({
	items: z.array(mobileOrderItemCreateRequestSchema).optional(),
	combos: z.array(comboCalculationDetailRequestSchema).optional(),
	table: z.uuid().nullish(),
	order_type_id: z.uuid().nullish().describe("Внутренний ID выбранного типа заказа (Здесь/С собой)"),
	locator: z.string().max(8).nullish(),
	comment: z.string().max(50).nullish(),
	tab_name: z.string().max(50).nullish(),
	promo_code: z.string().min(1).optional(),
});
